import KhachHangSearch from "./KhachHangSearch";

export default KhachHangSearch